import { defineComponent as _defineComponent } from 'vue'
interface InputProps {
  id: string
  value?: string | number | string[]
  errors?: string[]
  twClass: string | string[]
}

import { defineComponent, onBeforeMount, useSlots } from 'vue'
import { twMerge } from 'tailwind-merge'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Textarea',
  props: {
    id: null,
    value: null,
    errors: null,
    twClass: null
  },
  emits: ['input'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  id: string
  value?: string | number | string[]
  errors?: string[]
  twClass: string | string[]
};





function handleInput(event: InputEvent) {
  emits('input', (event.target as HTMLInputElement).value)
}
const slots = useSlots()

onBeforeMount(() => {
  // When a page with an input is loaded and the browser autofills the input, or
  // the user enters a value before hydration(mounted), the value will be
  // reset (because of the SSR). This problem is visible in Firefox
  // (for autofill) and also on all other browsers when the time between the
  // initial render and the vue hydration is long enough.
  const input = document.getElementById(props.id) as HTMLInputElement | null
  if (input?.value.trim()) {
    emits('input', input.value)
  }
})

return { __sfc: true,props, emits, handleInput, slots, twMerge }
}

})